import script from "./AppDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppDeleteModal.vue?vue&type=style&index=0&id=0866e316&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0866e316"]])

export default __exports__